export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-line-chart-line',
      title: 'Crecimiento compuesto sostenido',
      description: 'Tu inversión crece exponencialmente con el tiempo gracias al interés compuesto.'
    },
    {
      icon: 'ri-global-line',
      title: 'Diversificación automática',
      description: 'Invierte en las empresas más fuertes del mundo de forma automática.'
    },
    {
      icon: 'ri-bank-line',
      title: 'Supera métodos tradicionales',
      description: 'Históricamente más rentable que ahorrar en un banco tradicional.'
    },
    {
      icon: 'ri-time-line',
      title: 'Estrategia a largo plazo',
      description: 'Ideal para estrategias a mediano y largo plazo con resultados comprobados.'
    }
  ];

  return (
    <section className="py-24 px-6 lg:px-12 bg-gradient-to-b from-black to-[#0A1A35]">
      <div className="max-w-6xl mx-auto">
        {/* Título */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Invertir en índices: la estrategia que{' '}
            <span className="text-[#D4AF37]">supera a los métodos tradicionales</span>
          </h2>
        </div>

        {/* Grid de beneficios */}
        <div className="grid md:grid-cols-2 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-[#0A1A35] to-black p-8 rounded-2xl border border-[#D4AF37]/20 hover:border-[#D4AF37]/50 transition-all duration-300 hover:shadow-xl hover:shadow-[#D4AF37]/20"
            >
              <div className="flex items-start gap-6">
                <div className="w-16 h-16 flex items-center justify-center bg-[#D4AF37]/10 rounded-xl group-hover:bg-[#D4AF37]/20 transition-all duration-300">
                  <i className={`${benefit.icon} text-3xl text-[#D4AF37]`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-white mb-3">
                    {benefit.title}
                  </h3>
                  <p className="text-[#C5C7D0] leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
